import { defineComponent } from 'vue'

import useBookingListView from '@/composables/views/booking-list/useBookingListView'

import BookingListListItem from './BookingListListItem'

export default defineComponent(() => {
  const { bookingListQuery } = useBookingListView()

  return () => (
    <div class='w-full'>
      {bookingListQuery.data.value?.data.map((item) => {
        return (
          <BookingListListItem
            key={`booking-list-list-item-${item.id}`}
            item={item}
          />
        )
      })}
    </div>
  )
}, {
  name: 'BookingListList'
})
